// extracted by mini-css-extract-plugin
module.exports = {"loadWrapper":"LeftPannelLoading_loadWrapper__1pA2a","ant-skeleton-element":"LeftPannelLoading_ant-skeleton-element__3bv5I"};